export const links = [
    
    {
        "nombre" : "Transparencia",
        //"link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            }
        ]
    },
    {
        "nombre" : "Hidalgo Tiene Algo",
        "link" : "https://hidalgo.travel/",
        "submenu" : [
            {
                "subMenuNombre" : "Hidalgo Travel",
                "subMenuUrl": "https://hidalgo.travel/"
            },
            {
                //"subMenuNombre" : "Organismos Desconcentrados",
                //"subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            }
        ]
    },
    {
        "nombre" : "Servicios",
        "link" : "/s1",
    },
    {
        "nombre" : "Datos Abiertos",
        "link" : "",
        "submenu" : [
            {
                "subMenuNombre" : "Datos Abiertos",
                "subMenuUrl" : "/s2"
            },
            {
                "subMenuNombre" : "Sistema de Evaluación del Desempeño",
                "subMenuUrl" : "/Ed"
            },
        ]
    },
    {
        "nombre" : "Sistema de Control Interno",
        "link" : "/C1",
        
    },
    
    {
        "nombre" : "Encuesta de satisfacción",
        "link" : "https://bit.ly/Calidad_encuesta",
    },
]